export default {
  currentAccountId: '',
  currentAccount: {},
  currentAccountSettings: {},
  currentAccountUser: {},
  currentAccountUserGroups: [],
  currentAccountPermissions: {},
  currentAccountItemPermissions: {},
  currentAccountFeatureFlags: {},
  currentAccountIsPaused: false,
  recentlyUsedTags: {},
  timezones: [],
  completedCampaignsWithoutStats: [],
  targetsWithoutStats: [],
  affiliates: [],
  buyers: [],
  pingTreeTargetsWithoutStats: [],
  callPlans: [],
  status: {}
};